export type KeywordSearchContentClass = 'video' | 'audio';

/** Minimal shape we need off a search result; real `SearchResult`s satisfy it. */
type ResultLike = { contentClass: string };

const KEYWORD_SEARCH_ROUTES: Record<KeywordSearchContentClass, string> = {
    video: '/video/search',
    audio: '/audio/search',
};

/**
 * Pick the keyword-search media type for the latest conversational search
 * results. The feature supports video and audio; we default to video and only
 * route to audio when the results are exclusively audio. Anything else — video,
 * a mixed cross-asset turn, no results, or an unsupported class (e.g. images)
 * unintentionally slipping in — defaults to video until support is added
 * explicitly.
 */
export function resolveKeywordSearchContentClass(results: readonly ResultLike[]): KeywordSearchContentClass {
    const isAudioOnly = results.length > 0 && results.every((result) => result.contentClass === 'audio');
    return isAudioOnly ? 'audio' : 'video';
}

export function getKeywordSearchUrl(results: readonly ResultLike[]): string {
    return KEYWORD_SEARCH_ROUTES[resolveKeywordSearchContentClass(results)];
}
